import { SettingConst } from '@faire/web-api--source/types';

/**
 * Toggle to enable multimodal query product search
 */
export const ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220 =
  'ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220' as SettingConst<
    'ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
